import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import FifthSection from "./components/FifthSection";
import FirstSection from "./components/FirstSection/FirstSection";
import FourthSection from "./components/FourthSection";
import SecondSection from "./components/SecondSection/SecondSection";
import ThirdSection from "./components/ThirdSection";
import { WhatsApp } from "react-whatsapp-component";
import InstaIcon from "./components/InstaIcon";

function App() {
  return (
    <div>
      <FirstSection />
      <SecondSection />
      <ThirdSection />
      <FourthSection />
      <FifthSection />
      <InstaIcon />
      <WhatsApp
        phone={+5521994559105}
        text="Olá, gostaria de saber mais detalhes de como funciona o processo de registro da minha marca."
      />
    </div>
  );
}

export default App;
